<template>
  <div>
    
   <app-master>

       
       <app-large-banner></app-large-banner>

       <!-- about area end -->
    <div class="about-area pd-top-100 pd-bottom-70">
        <div class="container">
            <div class="row">
                <div class="col-lg-5 align-self-center">
                    <div class="section-title mb-lg-0">
                        <h2 class="title">Comfort and Elegance 
                            <!-- <br>Luxurius Home -->
                            </h2>
                        <p>Owning a property with us improves your quality of life and gives you peace of mind. Experience real comfort and safety in our fully furnished, roomy bungalows, keeping in mind that your perimeter and general areas of your interior are under 24/7 CCTV surveillance.
Enjoy a treated water system, a central sewage system, and uninterrupted electricity. Get absorbed in the picturesque landscape as you drive through the boulevard or saunter along the paved walkways.
</p>
                        <a class="btn-view-all-2" href="#">Learn More <i class="la la-long-arrow-right"></i></a>
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="row">
                        <div class="col-md-4 col-sm-6">
                            <a class="cat-single text-center" href="#">
                                <i class="fa fa-bed"></i>
                                <p>03 Bed</p>
                            </a>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <a class="cat-single text-center" href="#">
                                <i class="fa fa-bath"></i>
                                <p>03 Bathroom</p>
                            </a>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <a class="cat-single text-center" href="#">
                                <img src="assets/img/icons/14.png" alt="icons">
                                <p>01 Kitchen</p>
                            </a>
                        </div>
                        <!-- <div class="col-md-4 col-sm-6">
                            <a class="cat-single text-center" href="#">
                                <img src="assets/img/icons/15.png" alt="icons">
                                <p>Drawing room</p>
                            </a>
                        </div> -->
                        <div class="col-md-4 col-sm-6">
                            <a class="cat-single text-center" href="#">
                                <img src="assets/img/icons/16.png" alt="icons">
                                <p>300 m2</p>
                            </a>
                        </div>
                        <div class="col-md-4 col-sm-6">
                            <a class="cat-single text-center" href="#">
                                <i class="fa fa-car"></i>
                                <p>01 Parking</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- about area end -->



     <!-- apartments area start -->
    <div class="apartments-area bg-gray pd-top-100 pd-bottom-100">
        <div class="container">
            <div class="apartments-slider-2">
                <div class="item">
                    <div class="row">
                        <div class="col-xl-6 col-lg-7">
                            <div class="thumb">
                                <img src="/img/hom.png" alt="img">
                            </div>
                        </div>
                        <div class="col-lg-6 align-self-end">
                            <div class="details">
                                <span>01</span>
                                <h6>Special Features </h6>
                                <h2 class="title">Room Dimensions</h2>
                                <p>Each of our bungalows cover a total dimension of 300 square metres. With luxurious en-suite bedrooms and an airy living room and kitchen area, you are sure to maximise space and avoid clutter. </p>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <ul class="rld-list-style mb-3 mb-sm-0">
                                            <li><i class="fa fa-check"></i> Fully Furnished</li>
                                            <li><i class="fa fa-check"></i> 24/7 CCTV Surveillance</li>
                                            <li><i class="fa fa-check"></i> Uninterrupted power</li>
                                            <li><i class="fa fa-check"></i> Treated water system</li>
                                        </ul>
                                    </div>
                                    <div class="col-sm-6">
                                        <ul class="rld-list-style">
                                            <li><i class="fa fa-check"></i> Central sewage system</li>
                                            <li><i class="fa fa-check"></i> Ease of access</li>
                                            <li><i class="fa fa-check"></i> Defined drive </li>
                                            <li><i class="fa fa-check"></i> Paved sidewalks </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="row">
                        <div class="col-xl-6 col-lg-7">
                            <div class="thumb">
                                <img src="assets/img/others/2.png" alt="img">
                            </div>
                        </div>
                        <div class="col-lg-6 align-self-end">
                            <div class="details">
                                <span>01</span>
                                <h6>Enjoyable Spacings</h6>
                                <h2 class="title">Room Dimensions</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean vel eros quam. Sed sit amet dictum est, at fringilla enim. Praesent varius risus a convallis placerat. Aenean hendrerit lorem auctor ex </p>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <ul class="rld-list-style mb-3 mb-sm-0">
                                            <li><i class="fa fa-check"></i> Full Furnished</li>
                                            <li><i class="fa fa-check"></i> Royal touch Point</li>
                                            <li><i class="fa fa-check"></i> Minimal Decored</li>
                                            <li><i class="fa fa-check"></i> Tow way Road</li>
                                        </ul>
                                    </div>
                                    <div class="col-sm-6">
                                        <ul class="rld-list-style">
                                            <li><i class="fa fa-check"></i> Perfect land</li>
                                            <li><i class="fa fa-check"></i> Awesome view</li>
                                            <li><i class="fa fa-check"></i> 24/7 Security</li>
                                            <li><i class="fa fa-check"></i> Small Garden</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="item">
                    <div class="row">
                        <div class="col-xl-6 col-lg-7">
                            <div class="thumb">
                                <img src="assets/img/others/3.png" alt="img">
                            </div>
                        </div>
                        <div class="col-lg-6 align-self-end">
                            <div class="details">
                                <span>01</span>
                                <h6>Enjoyable Spacings</h6>
                                <h2 class="title">Room Dimensions</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean vel eros quam. Sed sit amet dictum est, at fringilla enim. Praesent varius risus a convallis placerat. Aenean hendrerit lorem auctor ex </p>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <ul class="rld-list-style mb-3 mb-sm-0">
                                            <li><i class="fa fa-check"></i> Full Furnished</li>
                                            <li><i class="fa fa-check"></i> Royal touch Point</li>
                                            <li><i class="fa fa-check"></i> Minimal Decored</li>
                                            <li><i class="fa fa-check"></i> Tow way Road</li>
                                        </ul>
                                    </div>
                                    <div class="col-sm-6">
                                        <ul class="rld-list-style">
                                            <li><i class="fa fa-check"></i> Perfect land</li>
                                            <li><i class="fa fa-check"></i> Awesome view</li>
                                            <li><i class="fa fa-check"></i> 24/7 Security</li>
                                            <li><i class="fa fa-check"></i> Small Garden</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="ap2-slider-controls">
                <!--slider-nav-->
                <div class="rld-slider-extra slider-extra">
                    <div class="text">
                        <span class="first">01 </span>
                        <span class="last"></span>
                    </div>
                    <!--text-->
                    <div class="ap2-list-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100">
                        <span class="slider__label sr-only"></span>
                    </div>
                    <div class="slider-nav rld-control-nav"></div>
                </div>
                <!--slider-extra-->
            </div>
        </div>
    </div>
    <!-- apartments area end -->


     <!-- call to action area start -->
    <div class="call-to-action-area pd-top-100">
        <div class="container">
            <div class="call-to-action style-two" style="background-image: url(/img/afford.png);">
                <div class="cta-content">
                    <h3 class="title">Contact With Our Property Agent</h3>
                    <router-link class="btn btn-white mb-2 mb-sm-0 mr-2" tag="a" to="/contact"> Make a Call </router-link>
                    <router-link class="btn btn-white mb-2 mb-sm-0 mr-xl-3 mr-0" tag="a" to="/property"> Get a Property </router-link>
                    <!-- <a class="btn btn-white mb-2 mb-sm-0 mr-2" href="#">Make a Call</a>
                    <a class="btn btn-white mb-2 mb-sm-0 mr-xl-3 mr-0" href="#">Get Appoinment</a> -->
                </div>
            </div>
        </div>
    </div>
    <!-- call to action area end -->

    <!-- gallery area start -->
    <div class="gallery-area pd-top-92">
        <div class="container">
            <div class="section-title">
                <h2 class="title">Photo Gallery</h2>
            </div>
            <div class="row">
                <div class="col-lg-7">
                    <div class="gallery-thumb">
                        <img src="/img/gal1.png" alt="img">
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="gallery-thumb">
                        <img src="/img/gal2.png" alt="img">
                    </div>
                    <div class="row">   
                        <div class="col-sm-7">  
                            <div class="gallery-thumb">
                                <img src="/img/gal3.png" alt="img">
                            </div>    
                        </div>
                        <div class="col-sm-5">  
                            <div class="gallery-thumb">
                                <img src="/img/gal4.png" alt="img">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- gallery area start -->

    <!-- floor-plan area start -->
    <div class="floor-plan-area pd-top-70 pd-bottom-90">
        <div class="container">
            <div class="row">
                <div class="col-xl-6 col-lg-7 align-self-center">
                    <div class="section-title mb-lg-0 mb-2">
                        <h2 class="title">Affordable Luxury</h2>
                        <p>With top-notch furnishing and finishing, each unit is superbly designed to accommodate your style. While luxurious homes are what we offer, acquiring one from us is far from a tall order.</p>
                        <div class="floor-list">
                            <div class="row">
                                <div class="col-md-4 col-sm-6">
                                    <div class="single-floor-list media">
                                        <div class="media-left">
                                            <i class="fa fa-bed"></i>
                                        </div>
                                        <div class="media-body">
                                            <h6>Living Room</h6>
                                            <p>20 x 16 sq feet</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <div class="single-floor-list media">
                                        <div class="media-left">
                                            <i class="fa fa-car"></i>
                                        </div>
                                        <div class="media-body">
                                            <h6>Garage</h6>
                                            <p>20 x 16 sq feet</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <div class="single-floor-list media">
                                        <div class="media-left">
                                            <img src="assets/img/icons/7.png" alt="img">
                                        </div>
                                        <div class="media-body">
                                            <h6>Dining Area</h6>
                                            <p>20 x 16 sq feet</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <div class="single-floor-list media">
                                        <div class="media-left">
                                            <i class="fa fa-bed"></i>
                                        </div>
                                        <div class="media-body">
                                            <h6>Bedroom</h6>
                                            <p>20 x 16 sq feet</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <div class="single-floor-list media">
                                        <div class="media-left">
                                            <i class="fa fa-bath"></i>
                                        </div>
                                        <div class="media-body">
                                            <h6>Bathroom</h6>
                                            <p>20 x 16 sq feet</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-md-4 col-sm-6">
                                    <div class="single-floor-list media">
                                        <div class="media-left">
                                            <img src="assets/img/icons/17.png" alt="img">
                                        </div>
                                        <div class="media-body">
                                            <h6>Gym Area</h6>
                                            <p>20 x 16 sq feet</p>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-5 align-self-center">
                    <img src="/img/afford.png" alt="img">
                </div>
            </div>
        </div>
    </div>

    <!-- Properties area start -->
    <div class="properties-area pd-bottom-70">
        <div class="container">
            <div class="section-title">
                <h2 class="title">Available Apartments</h2>
                <router-link class="btn-view-all" to="/property" tag="a">View All </router-link>
                <!-- <a class="btn-view-all" href="#">View All</a> -->
            </div>
            <div class="row">

                <div class="col-lg-3 col-sm-6" v-for="(estate_detail, index) in estate_details" :key="index+'estate_detail'">
                    <div class="single-feature">
                        <div class="thumb">
                            <img :src="estate_detail.featured_thumbnail" alt="img">
                            <a href="#"><i class="fa fa-heart"></i></a>
                        </div>
                        <div class="details">
                            <a href="#" class="feature-logo">
                                <img src="assets/img/icons/l3.png" alt="icons">
                            </a>
                            <!-- <p class="author"><i class="fa fa-user"></i> Vilma Jarvi By Redbrox</p> -->
                            <h6 class="title"><a href="#">{{ estate_detail.name }}</a></h6>
                            <h6 class="price">&#8358;{{ estate_detail.price | number_format }}/unit</h6>
                            <!-- <del>$790/mo</del> -->
                            <ul class="info-list">
                                <li><i class="fa fa-bed"></i> {{ estate_detail.keypoint.bedroom }} Bed</li>
                                <li><i class="fa fa-bath"></i> {{ estate_detail.keypoint.bathroom }} Bath</li>
                                <li><img src="assets/img/icons/7.png" alt="img"> {{ estate_detail.keypoint.area }} sqm.</li>
                            </ul>
                            <ul class="contact-list">
                                <li><a class="phone" href="#"><i class="fa fa-phone"></i></a></li>
                                <li><a class="message" href="#"><img src="assets/img/icons/8.png" alt="img"></a></li>
                                <router-link :to="{ name: 'PropertyDetails', params: { estate: estate_detail.estate_code,name: convertToSlug(estate_detail.name) } }" tag="a" class="btn btn-yellow"> View Details </router-link>
                                <!-- <li><a class="btn btn-yellow" href="#">View Details</a></li> -->
                            </ul>
                        </div>
                    </div>
                </div>

               
            
            </div>
        </div>
    </div>
    <!-- feature Properties area end -->




       

       <app-choose-us></app-choose-us>
       
       <app-partner></app-partner>
       





       
   </app-master>

        


  </div>
</template>

<script>
// @ is an alias to /src
import Master from "@/components/Master.vue";
import Partner from "@/components/Partner.vue";
import LargeBanner from "@/components/LargeBanner.vue"
import ChooseUs from "@/components/ChooseUs.vue"
import {seo} from "../Repositories/seo.js"
import {pick} from "../Repositories/pick.js"
import {vuesax} from "../Repositories/vuesax"
import { database } from "../Repositories/database"

export default {
  name: "Welcome",
   mixins: [seo,pick,vuesax,database],
  components: {
    "app-master" : Master,
    "app-partner": Partner,
    "app-large-banner": LargeBanner,
    "app-choose-us" : ChooseUs
    
  },
  created(){
       this.seoMetaData('Home' , '');
  }
};
</script>


<style>

.vs-notifications p {
    color: white!important;
}

.vs-notifications {
    position: fixed;
    z-index: 200000;
    padding: 0px 5px!important;
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 5px;
   
}



</style>
